import { Helmet } from 'react-helmet-async'

const SEO = ({
  title = 'Mocksy - AI-Powered Product Photo Transformation',
  description = 'Transform your product photos with AI in seconds. Upload, describe, and generate professional product photography variations instantly. Perfect for e-commerce, marketing, and social media.',
  keywords = 'AI product photos, product photography, AI image generation, e-commerce photos, product mockups, AI photo editor, professional product photos, automated product photography',
  ogImage = 'https://getmocksy.com/og-image.jpg',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  canonicalUrl,
}) => {
  const siteUrl = 'https://getmocksy.com'
  const fullCanonicalUrl = canonicalUrl || `${siteUrl}${window.location.pathname}`

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Mocksy" />

      {/* Twitter */}
      <meta property="twitter:card" content={twitterCard} />
      <meta property="twitter:url" content={fullCanonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="Mocksy" />
    </Helmet>
  )
}

export default SEO
